export default function (err, filename) {
  if (!filename) filename = ''
  let msg = `Ett kommunikationsfel har skett. Vänligen försök igen eller kontakta support. KOD: ${filename}-0000`

  /*
    const error = {
      code: 'PM-CREATEORDER-0000',
      message: 'Ett internt serverfel har skett. Vänligen försök igen eller kontakta support',
      additionalInformation: ''
    }
  */

  // Firebase: Om error kommer från en firebase funktion likt logout
  if (err.code) {
    switch (err.code) {
      case 'auth/user-token-expired':
        return 'Sessionen är ej längre giltig. Vänligen logga ut och in igen.'
      case 'auth/invalid-email':
        return 'Ogiltig email'
      case 'auth/argument-error':
        return 'Ogiltig email'
      case 'auth/user-not-found':
        return 'Ingen användare hittades'
      case 'auth/wrong-password':
        return 'Felaktigt lösenord'
      case 'auth/too-many-requests':
        return 'Du har försökt för många gånger. Vänta en stund'
      case 'ECONNABORTED':
        return 'Det tog för lång tid att kommunicera med serven. Vanligen försök igen.'
    }
  }

  if (err && err.message) {
    msg = `${err.message} KOD: ${err.code || `${filename}-0000`}`
  } else if (global.bugsnag && err.rawError) {
    global.bugsnagClient.notify(err.rawError, { severity: 'error' })
  }

  return msg
}
